<template>
  <div>
    <Row :gutter="gutter" :align="align" :justify="justify">
      <template v-for="(item,i) in fields">
        <Col :span="item.span || 24" :key="i">
          <ItemInfo :label-width="labelWidth" :label="item.label" :key="i" style="margin: 5px 0; min-height: 40px">
            <Input v-if="item.type === 'input'" v-model="data[item.key]" :clearable="item.clearable"
                   :placeholder="item.placeholder" :readonly="item.readonly" :disabled="item.disabled" style="width: 100%;"></Input>
            <Select v-else-if="item.type === 'select'" v-model="data[item.key]" :clearable="item.clearable"
                    :placeholder="item.placeholder" :readonly="item.readonly" :disabled="item.disabled" style="width: 100%;">
              <Option v-for="(select, sidx) in item.selectData" :key="sidx" :label="select.label"
                      :value="select.value"></Option>
            </Select>
            <DatePicker v-else-if="item.type === 'date' || item.type === 'datetime' || item.type === 'datetimerange'"
                        v-model="data[item.key]" :type="item.type" :placeholder="item.placeholder"
                        :readonly="item.readonly" :disabled="item.disabled" style="width: 100%;"></DatePicker>
            <InputNumber v-else-if="item.type === 'number'" v-model="data[item.key]" :clearable="item.clearable"
                         :placeholder="item.placeholder" :readonly="item.readonly"
                         :disabled="item.disabled" style="width: 100%;"></InputNumber>
            <Input v-else-if="item.type === 'textarea'" type="textarea" v-model="data[item.key]"
                   :clearable="item.clearable" :placeholder="item.placeholder" :readonly="item.readonly"
                   :disabled="item.disabled" style="width: 100%;"></Input>
            <Avatar v-else-if="item.type === 'avatar'" :src="data[item.key]"></Avatar>
            <span v-else-if="item.type === 'text'">{{ data[item.key] }}</span>
            <slot v-else-if="item.type === 'slot'" :name="item.key" :field="data[item.key]"></slot>
          </ItemInfo>
        </Col>
      </template>
    </Row>
  </div>
</template>

<script>
import ItemInfo from '../item-info/item-info'

export default {
  name: 'index',
  components: { ItemInfo },
  props: {
    gutter: {
      type: Number,
      default: null
    },
    align: {
      type: String,
      default: null
    },
    justify: {
      type: String,
      default: null
    },
    fields: {
      type: Array,
      default: () => {
      }
    },
    labelWidth: {
      type: Number,
      default: null
    },
    data: {
      type: Object,
      default: () => {
      }
    }
  },
  data () {
    return {}
  },
  methods: {}
}
</script>

<style scoped>

</style>
